export function cookiesModal() {
    const cookiesModal = document.querySelector('#cookiesModal');
    if (!cookiesModal)
        return;
    function initializeTabs(containerSelector, tabSelector, contentSelector) {
        const container = cookiesModal.querySelector(containerSelector);
        const tabs = Array.from(container.querySelectorAll(tabSelector));
        const contents = Array.from(cookiesModal.querySelectorAll(contentSelector));
        let activeTab = 0;
        function setActiveTab(newTabIndex) {
            if (newTabIndex === activeTab)
                return;
            tabs[activeTab].classList.remove('active');
            contents[activeTab].classList.remove('active');
            tabs[newTabIndex].classList.add('active');
            contents[newTabIndex].classList.add('active');
            activeTab = newTabIndex;
        }
        container.addEventListener('click', (event) => {
            const clickedTab = event.target.closest(tabSelector);
            if (!clickedTab)
                return;
            const newIndex = tabs.indexOf(clickedTab);
            if (newIndex !== -1) {
                setActiveTab(newIndex);
            }
        });
    }
    initializeTabs('.cookies-modal-tabs', '.tabs-item', '.content-item');
    initializeTabs('.details-tabs', '.tabs-item', '.details-option');
}
